import React, {useContext, useState} from 'react'
import {useForm} from 'react-hook-form'
import FormInput from '../../../../components/Inputs/FormInput/FormInput'
import NewModal from '../../../../components/NewModal/NewModal'
import Modal from '../../../../components/Modal'
import Form from '../../../../components/Form/Form'
import {useHttp} from '../../../../hooks/http.hook'
import {AuthContext} from '../../../../context/AuthContext'
import {Patient_API} from '../../PatinetAPI'
import PasswordInput from '../../../../components/PasswordInput'
import {cleanPhoneMask, formatDate, ucFirst} from '../../../../utils/utils'
import DateInput from '../../../../components/DateInput'
import moment from 'moment'
import CheckboxInput from "../../../../components/Inputs/CheckboxInput/CheckboxInput";
import styled from "styled-components";

function SignInV2() {
    const {register, unregister, setValue, getValues, watch, errors, reset, setError, handleSubmit} = useForm()
    const {request} = useHttp()
    const {login} = useContext(AuthContext)
    const {signIn, registerSMS, registerFio} = Patient_API.signIn
    const baseURL = process.env.REACT_APP_BASE_URL
    const [registerStep, setRegisterStep] = useState(0) // 1: general, 2: fio , 3: sms

    const [userData, setUserData] = useState({patient_id: '', fio: ''})
    const [phone, setPhone] = useState({
        value: "",
        error: ""
    })
    const [prems, setPrems] = useState(false)

    const [withoutMiddleName, setMiddleName] = useState(false)

    const changeRegisterStep = (event, step) => {
        event.preventDefault()
        setRegisterStep(step)
    }
    const sign = async (formData) => {
        unregister('retryPassword')
        if (validate()) {
            const {data, status} = await request(`${baseURL}${signIn().api}`, signIn().method, {
                ...formData,
                phone: phone.value,
                dob: moment(formData.dob).format("YYYY-MM-DD")
            }, {})
            status === 200 && data.message === 'фио' && setRegisterStep(2)
            status === 200 && data.message === 'смс' && setRegisterStep(3)
            status === 200 && setUserData({...userData, patient_id: data.data[0]?.userId})
            status === 400 && setError('email', {type: 'exists', message: 'Данный E-Mail уже существует'})
        }
    }

    const phoneHandler = (key, value) => {
        setPhone(prev => ({...prev, [key]: value}))
    }

    const signFio = async (formData) => {
        setUserData({
            ...userData,
            fio: `${ucFirst(formData.lastName)} ${ucFirst(formData.firstName)} ${ucFirst(formData.middleName)}`.trim()
        })
        const {data, status} = await request(`${baseURL}${registerFio().api}`, registerFio().method, {
            ...userData,
            fio: `${ucFirst(formData.lastName)} ${ucFirst(formData.firstName)} ${ucFirst(formData.middleName)}`.trim()
        }, {})
        status === 201 ? setRegisterStep(3) : setRegisterStep(2)
        reset()
    }
    const signSMS = async () => {
        window.location.href = '/'
    }
    const validate = () => {
        if (cleanPhoneMask(phone.value).length < 12) {
            phoneHandler("error", "Неправильный номер телефона.")
            return false
        }

        phoneHandler("error", "")
        return true
    }
    return (
        <Modal onOutsideClick={() => {
            window.location.href = '/'
        }} styles={{top: '0'}}>
            {
                registerStep === 0 ? (
                    <>
                        <NewModal
                            closeHandler={_ => window.location.href = '/'}
                            title={'Важная информация'}>

                            <Form submitButtonText={"Я прочитал"} submitHandler={event => changeRegisterStep(event, 1)}>
                                <StyledInfoModal>
                                    <p>
                                        <strong> Номер телефона</strong>
                                        <li> При регистрации обязательно указань номер телефона,
                                            который указан при прохождении обследования.
                                        </li>
                                    </p>
                                    <p>
                                        <strong> История обследования</strong>
                                        <li> Если после 7 рабочих дней не отображается история
                                            прохождения обследования, обратитесь в чат на сайте.
                                        </li>
                                    </p>
                                    <p>
                                        <strong> Email</strong>
                                        <li>
                                            Обязательно указать адрес электронной почты к которой
                                            у Вас есть доступ, так как после прохождения регистрации на
                                            почту придет ссылка на активацию аккаунта.
                                        </li>
                                    </p>
                                </StyledInfoModal>

                            </Form>


                        </NewModal>
                    </>
                ) : ""
            }
            {registerStep === 1 ?
                <NewModal
                    closeHandler={_ => window.location.href = '/'}
                    title={'Регистрация'}
                    errors={{
                        ...errors,
                        dontLookLike: errors.retryPassword?.type === 'dontLookLike' && {message: 'Пароли не совпадают'},
                        invalidPassword: phone.error && {message: phone.error},

                    }}
                >


                    <Form submitDisabled={errors === {} || !prems} submitButtonText={'Продолжить'}
                          submitHandler={handleSubmit(sign)}>

                        <FormInput
                            hideIcon
                            useNumberFormat={true}
                            name={'phone'}

                            format='+7(###)###-##-##'
                            allowEmptyFormatting={true}
                            // type={'tel'}
                            mask={'_'}
                            onChange={e => phoneHandler('value', e.target.value)}
                        >
                            Номер телефона
                        </FormInput>

                        <DateInput
                            title='Дата рождения'
                            name={'dob'}
                            value={watch('dob')}
                            reff={register}
                            onChange={(date) => {
                                setValue('dob', date)
                            }}
                        />
                        <input type='hidden' name={'dob'} id={'dob'}
                               ref={register({required: 'Укажите дату рождения'})}/>
                        {/*<FormInput*/}
                        {/*  name={'dob'}*/}
                        {/*  type={'date'}*/}
                        {/*  hideIcon={true}*/}
                        {/*  value={watch('login')}*/}
                        {/*  reff={register({ required: 'Укажите дату рождения', min: '1920-01-01', max: '2005-01-01' })}>*/}

                        {/* Дата рождения*/}
                        {/*</FormInput>*/}

                        <FormInput name={'email'}
                                   type={'email'}

                                   hideIcon={true}
                                   reff={register({required: 'Укажите электронную почту'})}
                        >
                            E-Mail
                        </FormInput>


                        <PasswordInput
                            name={'password'}
                            type={'password'}
                            hideIcon={true}
                            reff={register}
                        >
                            Пароль
                        </PasswordInput>


                        <FormInput name={'retryPassword'}
                                   type={'password'}
                                   maxLength={15}
                                   hideIcon={true}
                                   reff={register({
                                       validate:
                                           {
                                               dontLookLike: value => {
                                                   return (watch('password') === value)
                                               }
                                           }
                                   })}
                        >
                            Повторите пароль
                        </FormInput>

                        <StyledPrems>
                            <CheckboxInput checked={prems} onClick={_ => setPrems(!prems)} title={<div className={'a'}>
                                <p>
                                    Я согласен с <a target="_blank"
                                                    href="confiditional/privacy-policy.pdf"> Политикой
                                    Конфиденциальности </a> и <a target="_blank"
                                                                 href="confiditional/personal.pdf">Пользовательского
                                    соглашения</a>
                                </p>

                            </div>}/>
                        </StyledPrems>
                    </Form>
                </NewModal>
                : ''}

            {registerStep === 2 ?
                <NewModal
                    title={'Укажите ФИО'}
                    errors={{...errors}}
                >
                    <Form submitButtonText={'Продолжить'} submitHandler={handleSubmit(signFio)}>

                        <FormInput
                            hideIcon
                            important
                            title={'Фамилия'}
                            name={'lastName'}
                            reff={register({required: true})}
                        />

                        <FormInput
                            hideIcon
                            important
                            title={'Имя'}
                            name={'firstName'}
                            reff={register({required: true})}
                        />

                        <FormInput
                            hideIcon
                            important={!withoutMiddleName}
                            disabled={withoutMiddleName}
                            title={'Отчество'}
                            name={'middleName'}
                            reff={register({required: !withoutMiddleName})}
                        />
                        <CheckboxInput checked={withoutMiddleName} onClick={_ => setMiddleName(prev => !prev)}
                                       title={"Не имею отчества"}/>

                    </Form>

                </NewModal>
                : ''}

            {registerStep === 3 ?
                <NewModal title={'Подтверждение'} errors={{...errors}}>
                    <Form submitButtonText={'Продолжить'} submitHandler={handleSubmit(signSMS)}>
                        <div style={{textAlign: 'center'}}>
                            На указанный Вами e-mail отправлено письмо. Пожалуйста, перейдите по ссылке из письма для
                            подтверждения
                            аккаунта.
                        </div>
                        {/*<a onClick={_=>registerFio()} className={'codeSMS'} href={"#"}>Выслать пароль повторно</a>*/}

                    </Form>
                </NewModal>
                : ''}

            {registerStep === 5 && (
                <NewModal title={'Подтверждение'}
                          errors={{...errors}}

                >
                    <Form submitButtonText={'Продолжить'} submitHandler={handleSubmit(signSMS)}>


                        {/*<a onClick={_=>registerFio()} className={'codeSMS'} href={"#"}>Выслать пароль повторно</a>*/}

                    </Form>
                </NewModal>
            )}
        </Modal>

    )
}

const StyledInfoModal = styled.div`
  p {
    margin-bottom: 20px;
  }

  li {
    font-weight: normal;
  }

`
const StyledPrems = styled.div`
  .a {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 12px;
    align-items: center;

    a {
      text-decoration: underline;
      margin-bottom: 5px;
      margin-right: 5px;
    }
  }

  font-size: 14px;

`
export default SignInV2